import { Component } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { StatusBar } from '@capacitor/status-bar';
import { MenuController } from '@ionic/angular';
import { GlobalService } from './global.service';

interface AppMenuPage {
    id: string;
    title: string;
    title_orig: string;
    hide: boolean;
    url?: string;
    icon?: string;
    divider?: boolean;
}

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent {
    fakei18n = {
        tr: (txt: string) => {
            // This is a fake translation function used to set the initial titles of the menu items.
            // The real translations will be loaded later in the SettingsPage and updated accordingly.
            return txt;
        }
    };

    public appPages: AppMenuPage[] = [
        { id: 'home', title: this.fakei18n.tr('Overzicht'), url: '/home', icon: 'home', hide: false, title_orig: '' },
        { id: 'logbook', title: this.fakei18n.tr('Logboek'), url: '/logbook', icon: 'alarm', hide: false, title_orig: '' },
        { id: 'iolist', title: this.fakei18n.tr('I/O-lijst'), url: '/iolist', icon: 'list', hide: false, title_orig: '' },
        { id: 'canopen', title: this.fakei18n.tr('[*]Canopen'), url: '/canopen', icon: 'bus', hide: false, title_orig: '' },
        { id: 'liftsettings', title: this.fakei18n.tr('Instellingen Lift'), url: '/liftsettings', icon: 'build', hide: false, title_orig: '' },
        { id: 'statistics', title: this.fakei18n.tr('[en]Statistics'), url: '/statistics', icon: 'stats-chart', hide: false, title_orig: '' },
        { id: 'analyser', title: this.fakei18n.tr('Analyser'), url: '/analyser', icon: 'pulse-outline', hide: false, title_orig: '' },
        { id: 'divider-main', title: '', url: '', divider: true, hide: false, title_orig: '' },
        { id: 'liften', title: this.fakei18n.tr('Liften'), url: '/liften', icon: 'earth', hide: this.global.comm.type === 'CLOUD', title_orig: '' },
        { id: 'settings', title: this.fakei18n.tr('Instellingen App'), url: '/settings', icon: 'settings', hide: false, title_orig: '' },
        { id: 'help', title: this.fakei18n.tr('Help'), url: '/help', icon: 'help-circle', hide: false, title_orig: '' },
        { id: 'about', title: this.fakei18n.tr('[en]About'), url: '/about', icon: 'information-circle', hide: false, title_orig: '' },
    ];

    trackByMenuId(index: number, page: AppMenuPage): string {
        return page.id;
    }

    async closeMenu(): Promise<void> {
        await this.menuController.close();
    }

    constructor(
        public global: GlobalService,
        private menuController: MenuController,
    ) {
        this.configureStatusBar();

        for (const page of this.appPages) {
            page.title_orig = page.title;
        }
    }

    private async configureStatusBar(): Promise<void> {
        if (Capacitor.getPlatform() !== 'android') {
            return;
        }

        try {
            await StatusBar.setOverlaysWebView({ overlay: false });
        } catch {
            // Ignore startup status bar errors on unsupported environments.
        }
    }
}
